import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { GrayscalePalette } from '@tcl-boron-colors/colors';

export const useModalStyles: (data?: {
  theme?: Jss.Theme;
}) => Classes<'root' | 'overlay' | 'overlayAfter' | 'overlayBefore' | 'contentBefore' | 'contentAfter'> =
  createUseStyles({
    root: {
      backgroundColor: `${GrayscalePalette[100]}`,
      borderRadius: '10px',
      boxShadow: `0 3px 4px 2px ${GrayscalePalette[300]}`,
      left: '50%',
      outline: 'none',
      paddingTop: '32px',
      paddingBottom: '32px',
      paddingLeft: '32px',
      paddingRight: '0px',
      position: 'absolute',
      top: '100px',
      transform: 'translateX(-50%)',
      opacity: 0,
      transition: 'top 150ms ease-out, opacity 150ms ease-out',
    },
    contentAfter: {
      top: '150px',
      opacity: 1,
    },
    contentBefore: {
      top: '100px',
      opacity: 0,
    },
    overlay: {
      backgroundColor: `rgba(41, 41, 61, 0.05)`,
      bottom: '0px',
      left: '0px',
      position: 'fixed',
      right: '0px',
      top: '0px',
      zIndex: 1,
      transition: 'backdrop-filter 300ms ease-out',
      backdropFilter: 'blur(0px)',
    },
    overlayAfter: {
      backdropFilter: 'blur(7px)',
    },
    overlayBefore: {
      backdropFilter: 'blur(0px)',
    },
  });
